<template>
    <div class="chat-content-scroll-area border border-solid d-theme-border-grey-light" style="padding-top:60px; margin-bottom:60px;">
    <div id="component-chat-log" class="m-4" v-if="chatData">
        <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">
            <template v-if="chatData[index-1]">
                <vs-divider v-if="!isSameDay(msg.created_at, chatData[index-1].created_at)" class="msg-time">
                    <span>{{ toDate(msg.created_at) }}</span>
                </vs-divider>
                <div class="spacer mt-4" v-if="hasSentPreviousMsg(chatData[index-1].sender, msg.sender == 0)"></div>
            </template>
            <template v-else>
                <vs-divider class="msg-time">
                    <span>{{ toDate(msg.created_at) }}</span>
                </vs-divider>
            </template>

            <div class="flex items-start" :class="[{'flex-row-reverse' : msg.sender == 0}]">

                <template v-if="chatData[index-1]">
                    <div v-if="!(hasSentPreviousMsg(chatData[index-1].sender, msg.sender == 0) || !isSameDay(msg.created_at, chatData[index-1].created_at))"></div>
                </template>

                <div class="msg break-words relative shadow-md rounded px-4 pt-4 mb-2 rounded-lg" :class="{'bg-primary-gradient text-white': msg.sender == 1, 'border border-solid border-grey-light bg-white': msg.sender == 0}" style="max-width: 80%;">
                    <div v-if="msg.type == 'message'">
                        <span style="white-space: pre-line;">{{ msg.value }}</span>
                        <br/>
                    </div>
                    <div v-else-if="msg.type == 'file'">
                        <div class="p-4">
                            <a :href="srcFile(msg.value.url)" target="_blank" style="text-decoration: none;">
                                <img class="m-0" style="width: 40px;" :src="msg.value.icon" />
                                <span class="pl-4" style="color: #333;">{{ msg.value.name }}</span>
                            </a>
                        </div>
                    </div>
                    <div v-else-if="msg.type == 'factor'">
                        <div>
                            <span class="bold">اطلاعات صورت حساب</span>
                            <span style="display: block;">{{msg.value.subject}}</span>
                            <span style="display: block;" class="mt-3">مبلغ کل: {{msg.value.sum}} تومان</span>
                            <span style="display: block;" class="mt-3">مبلغ پیش پرداخت: {{msg.value.price}} تومان</span><br/>
                            <span style="display: block;" class="mt-3 bold">{{msg.value.title}}</span>
                            
                            <vs-table stripe :data="msg.value.fields" style="color:#444;">

                                <template slot="thead">
                                    <vs-th>عنوان</vs-th>
                                    <vs-th>تعداد</vs-th>
                                    <vs-th>فی</vs-th>
                                    <vs-th>قیمت</vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td>
                                            {{data[indextr].title}}
                                        </vs-td>
                                        <vs-td>
                                            {{data[indextr].quantity}}
                                        </vs-td>
                                        <vs-td>
                                            {{data[indextr].price}}
                                        </vs-td>
                                        <vs-td>
                                            {{data[indextr].total_price}}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                            <p style="white-space: pre-wrap" class="pt-3">
                                <span v-html="msg.value.text"></span>
                            </p>

                        </div>
                    </div>
                    <small class="">{{ setClock(msg.created_at) }}</small>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>


<script>
// import axios from 'axios'
import Pusher from 'pusher-js'


export default {
    props: {
        orderId: Number
    },

    data() {
		return{
            message: '',
            // chatData: []
		}
	},

    components: {
    },

    watch: { 
        orderId: function(newVal) {
            this.$vs.loading()
            this.$store.dispatch("getMessages", newVal).then(() => {
                this.$vs.loading.close()
            }).catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'خطا در اتصال به اینترنت',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            })
        },

        message:function(newVal) {
            // if(newVal.sender == 0){
                if(newVal.order_id == this.orderId){
                    this.$store.commit('addMessage', newVal)
                }
            // }
        },
    },


    created() {
        this.scrollToBottom()
        this.$vs.loading()
        // this.chatData = []
        this.$store.dispatch("getMessages", this.orderId).then(() => {
            // this.chatData = res.data
            this.$vs.loading.close()
        }).catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
                title: '',
                text: 'خطا در اتصال به اینترنت',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
    },

    methods: {
        isSameDay(time_to, time_from) {
            const date_time_to = time_to.split(" ");
            const date_time_from = time_from.split(" ");
            return date_time_to[0] === date_time_from[0]
        },

        toDate(date) {
            const date_time = date.split(" ");
            return date_time[0]
        },

        setClock(date) {
            const date_time = date.split(" ");
            return date_time[1]
        },

        srcFile(src) {
            let newSrc = `${src}`.replace('storage/','api')
            newSrc = newSrc.replace(/[/\\]/g ,'--')
            newSrc = newSrc.replace('api','api/download/')
            // let newSrc = `${src}`.replace(/'/'$/, "--")
            // newSrc = newSrc.replace('storage','api/download')
            return 'https://appapi.akambc.com/' + newSrc
        },

        payFactor() {
            window.open()
        },

        scrollToBottom() {
            this.$nextTick(() => {
                var elmnt = document.getElementById("component-chat-log");
                var y = elmnt.scrollHeight;
                window.scrollTo(0,y);
            });
        },
    },

    updated() {
        this.scrollToBottom();
    },

    mounted() {
        var pusher = new Pusher('04ca5914372c75e40ed7', {
        cluster: 'eu'
        });

        var channel = pusher.subscribe('my-channel');
        channel.bind('my-event', function(data) {
        this.message = data.message
            this.scrollToBottom();
        }, this);
        
        var height = screen.height - 300
        document.getElementById("component-chat-log").style.minHeight = height + 'px';
        this.scrollToBottom();
    },

    computed: {
        chatData() {
            return this.$store.state.chat.messages
        },

        hasSentPreviousMsg() {
            return (last_sender, current_sender) => last_sender == current_sender
        },
    }
}
</script>

<style scoped>
.file-body {
    background-color: #333;
}

.bold {
    font-weight: 800;
}

.vs-button:hover {
    background-color: #fb8103!important;
}
</style>